import { concat, copy, toBase64Url, utf8 } from './bytes.js';
import { canonicalize } from './jcs.js';
/**
 * Domain-separation tags. Every signed or hashed structure gets its own tag so that a signature
 * or passkey assertion produced for one purpose can never be replayed as another.
 */
export const DOMAIN = {
    deviceEndorsement: 'viko/device-endorsement/v1',
    command: 'viko/command/v1',
    stepUp: 'viko/step-up/v1',
    revocations: 'viko/revocations/v1',
    enrollment: 'viko/enrollment/v1',
    credentialSet: 'viko/credential-set/v1',
    daemonAuth: 'viko/daemon-auth/v1',
    sas: 'viko/sas/v1',
    payload: 'viko/payload/v1',
};
export async function sha256(data) {
    return new Uint8Array(await globalThis.crypto.subtle.digest('SHA-256', copy(data)));
}
/** `utf8(domain) || 0x00 || utf8(JCS(value))` — the exact bytes that get signed or hashed. */
export function domainSeparated(domain, value) {
    return concat(utf8(domain), new Uint8Array([0]), utf8(canonicalize(value)));
}
/** SHA-256 over the domain-separated canonical encoding of `value`. */
export async function hashCanonical(domain, value) {
    return sha256(domainSeparated(domain, value));
}
export async function hashCanonicalB64(domain, value) {
    return toBase64Url(await hashCanonical(domain, value));
}
//# sourceMappingURL=hash.js.map